export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $getAccessToken, $login } = useNuxtApp();

  if (!import.meta.client) {
    return;
  }

  // Skip static assets, well-known paths, and health checks
  if (
    to.path.startsWith("/_nuxt/") ||
    to.path.startsWith("/.well-known/") ||
    to.path === "/api/health"
  ) {
    return;
  }

  if (!to.path.startsWith("/portal")) {
    return;
  }

  try {
    const accessToken = await $getAccessToken();

    if (!accessToken) {
      console.warn("No access token, redirecting to login");
      await $login();
      return abortNavigation();
    }
  } catch (error) {
    console.error("Authentication error:", error);
    // Only login if it's not a token acquisition error
    if (!(error?.message?.includes("No API access token"))) {
      await $login();
      return abortNavigation();
    }
  }
});


// export default defineNuxtRouteMiddleware(async (to) => {
//   const { $getAccessToken, $login } = useNuxtApp();

//   if (!import.meta.client) {
//     return;
//   }

//   if (
//     to.path.startsWith("/_nuxt/") ||
//     to.path.startsWith("/.well-known/") ||
//     to.path === "/api/health"
//   ) {
//     return;
//   }

//   if (!to.path.startsWith("/portal")) {
//     return;
//   }

//   if (typeof $getAccessToken !== "function" || typeof $login !== "function") {
//     console.warn("Auth plugin not ready yet, blocking portal navigation once.");
//     return abortNavigation();
//   }

//   try {
//     const accessToken = await $getAccessToken();

//     if (!accessToken) {
//       console.warn("No access token, redirecting to login");
//       await $login(to.fullPath);
//       return abortNavigation();
//     }
//   } catch (error) {
//     console.error("Authentication error:", error);

//     if (
//       error?.errorCode === "interaction_in_progress" ||
//       error?.message?.includes("interaction_in_progress")
//     ) {
//       return abortNavigation();
//     }

//     if (!(error?.message?.includes("No API access token"))) {
//       await $login(to.fullPath);
//       return abortNavigation();
//     }
//   }
// });